import { Pipe, PipeTransform } from '@angular/core';

import { PessoaContato } from '../pessoa-contato';
import { PessoaContatoFilter } from './pessoa-contato-filter';

@Pipe({
    name: 'pessoaContatoFilter',
    pure: false
})
export class PessoaContatoFilterPipe implements PipeTransform {
    transform(contatos: PessoaContato[] = [], filter: PessoaContatoFilter): PessoaContato[] {
        if (!contatos || contatos.length === 0 || !filter) {
            return contatos;
        }

        return contatos.filter(contato => {
            // Pesquisa
            let filterPsq = true;
            if (filter.filterPsq && filter.filterPsq.trim().length > 0) {
                filterPsq = contato.nome.toLocaleLowerCase().includes(filter.filterPsq.toLocaleLowerCase());
            }

            // Situações
            let situacoes = true;
            if (filter.situacoes && filter.situacoes.length > 0) {
                situacoes = filter.situacoes.includes(contato.situacao);
            }

            // Tipos
            let tipos = true;
            if (filter.tipos && filter.tipos.length > 0) {
                tipos = filter.tipos.includes(contato.tipo);
            }

            return filterPsq && situacoes && tipos;
        });
    }
}
